import { useState, useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesGrid from "@/components/landing/FeaturesGrid";
import TryNowSection from "@/components/landing/TryNowSection";
import TechArchitecture from "@/components/landing/TechArchitecture";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import DemoModal from "@/components/landing/DemoModal";
import TrialModal from "@/components/landing/TrialModal";

// Track page view
const trackPageView = async () => {
  try {
    await fetch(`${window.location.origin}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent
      })
    });
  } catch (e) {
    // Silently fail - analytics shouldn't break the app
  }
};

export default function LandingPage() {
  const [demoModalOpen, setDemoModalOpen] = useState(false);
  const [trialModalOpen, setTrialModalOpen] = useState(false);

  // Track page view on mount
  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFDFD]" data-testid="landing-page">
      <Navbar 
        onDemoClick={() => setDemoModalOpen(true)} 
      />
      
      <main>
        <HeroSection 
          onDemoClick={() => setDemoModalOpen(true)}
          onTrialClick={() => setTrialModalOpen(true)}
        />
        
        <FeaturesGrid />
        
        <TryNowSection />
        
        <TechArchitecture />
        
        <ContactSection />
      </main>
      
      <Footer />
      
      {/* Modals */}
      <DemoModal 
        isOpen={demoModalOpen} 
        onClose={() => setDemoModalOpen(false)} 
      />
      <TrialModal 
        isOpen={trialModalOpen} 
        onClose={() => setTrialModalOpen(false)} 
      />
    </div>
  );
}
